// Minimal i18n layer. English ships bundled (i18n/en.json — esbuild inlines
// the import); other locales lazy-load in Phase 2 via extend(). Keys are flat
// + namespaced ('common.save', 'billing.active'). Every string in code touched
// during Phase 1 must go through t() — untouched legacy strings get extracted
// opportunistically. Form-schema labels are CONTENT, not UI: English-only v1.

import en from '../../i18n/en.json';

const tables = { en };

let _locale = 'en';

export function setLocale(locale) {
  const base = (locale ?? '').split('-')[0];
  _locale = tables[locale] ? locale : tables[base] ? base : 'en';
}

export function extend(locale, entries) {
  tables[locale] = { ...(tables[locale] ?? {}), ...entries };
}

export function t(key, params) {
  let s = tables[_locale]?.[key] ?? tables.en[key] ?? key;
  if (params) for (const [k, v] of Object.entries(params)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}

// Static-markup pass: <el data-i18n="key"> gets its text replaced, and
// data-i18n-placeholder swaps the placeholder attribute. English markup stays
// authored inline (readable source, works before the bundle runs); this pass
// only rewrites when the active locale differs from English.
export function apply(root = document) {
  if (_locale === 'en') return;
  root.querySelectorAll('[data-i18n]').forEach(el => {
    el.textContent = t(el.dataset.i18n);
  });
  root.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
    el.setAttribute('placeholder', t(el.dataset.i18nPlaceholder));
  });
}
